// import logo from './logo.svg';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./index.css";
import Index from "./pages/Index";
import Cursos from "./pages/Cursos";
import Contacto from "./pages/Contacto";
import Footer from "components/Footer";
import ExamenesInternacionales from "pages/ExamenesInternacionales";
import Instructores from "pages/instructores";
import Nosotros from "pages/Nosotros";
import Noticias from "pages/noticias";
import {Pqrfs} from "pages/Pqrfs";
import Testimonios from "pages/Testimonios";
import Gracias from "pages/Gracias";
import Entrenamientos from "pages/entrenamientos";
import Ielts from "pages/Ielts";
import Aptis from "pages/Aptis";
import Toefl from "pages/Toefl";
import Oopt from "pages/Oopt";
import ScrollToTop from "hooks/ScrollToTop";
import PublicLayout from "layouts/PublicLayout";
import Menu from "components/Menu/Menu";
import Teachers from "pages/Teachers";
import CursosIngles from "pages/CursosIngles";
import CursosLayout from "layouts/CursosLayout";
import dataCursoBasico from "../src/data/eficiencia.json";
import dataHabilidades from "../src/data/habilidadesEspecificas.json";
import dataCursoPersonalizado from "../src/data/cursoPersonalizado.json";
import dataCursoEspecializado from "../src/data/cursoEspecializado.json";
import dataCursoVacaciones from "../src/data/cursoVacaciones.json";
import dataCursoBkids from "../src/data/cursosBkids.json";
import PoliticaDatos from "pages/PoliticaDatos";
import Test from "pages/Test";

// import { useRouteColor } from "../src/hooks/useRouteColors";
function App() {
  // const {bg} = useRouteColor();
  return (
    <>
      <Router>
        <ScrollToTop />
        <Menu />
        <Switch>
          <Route path={"/gracias"}>
            <Gracias />
          </Route>
          <Route
            path={[
              "/cursos",
              "/cursos/cursos-basicos",
              "/cursos/bkids",
              "/cursos/cursos-por-habilidades",
              "/cursos/cursos-especializado",
              "/cursos/cursos-personalizados",
              "/cursos/cursos-de-vacaciones",
              "/cursos/cursos-de-ingles",
            ]}
          >
            <Switch>
              <Route path={"/cursos/cursos-de-ingles"}>
                <CursosIngles />
              </Route>
              <Route path={"/cursos/cursos-de-vacaciones"}>
                <CursosLayout data={dataCursoVacaciones} />
              </Route>
              <Route path={"/cursos/cursos-especializado"}>
                <CursosLayout data={dataCursoEspecializado} />
              </Route>
              <Route path={"/cursos/cursos-personalizados"}>
                <CursosLayout data={dataCursoPersonalizado} />
              </Route>
              <Route path={"/cursos/cursos-por-habilidades"}>
                <CursosLayout data={dataHabilidades} />
              </Route>
              <Route path="/cursos/cursos-basicos">
                <CursosLayout data={dataCursoBasico} />
              </Route>
              <Route path={"/cursos/bkids"}>
                <CursosLayout data={dataCursoBkids} />
              </Route>
              <Route path="/cursos">
                <Cursos />
              </Route>
            </Switch>
          </Route>
          <Route
            path={[
              "/certificaciones",
              "/certificaciones/ielts",
              "/certificaciones/toefl",
              "/certificaciones/aptis",
              "/certificaciones/oopt",
            ]}
          >
            <PublicLayout>
              <Switch>
                <Route path={"/certificaciones/oopt"}>
                  <Oopt />
                </Route>
                <Route path={"/certificaciones/aptis"}>
                  <Aptis />
                </Route>
                <Route path={"/certificaciones/toefl"}>
                  <Toefl />
                </Route>
                <Route path={"/certificaciones/ielts"}>
                  <Ielts />
                </Route>
                <Route path={"/certificaciones"}>
                  <ExamenesInternacionales />
                </Route>
              </Switch>
            </PublicLayout>
          </Route>
          <Route
            path={[
              "/nosotros",
              "/nosotros/teachers",
              "/nosotros/equipo",
              "/nosotros/testimonios",
              "/nosotros/noticias",
              "/nosotros/contactanos",
            ]}
          >
            <PublicLayout>
              <Switch>
                <Route path={"/nosotros/teachers"}>
                  <Teachers />
                </Route>
                <Route path={"/nosotros/noticias"}>
                  <Noticias />
                </Route>
                <Route path={"/nosotros/testimonios"}>
                  <Testimonios />
                </Route>
                <Route path={"/nosotros/contactanos"}>
                  <Contacto />
                </Route>
                <Route path={"/nosotros"}>
                  <Nosotros />
                </Route>
              </Switch>
            </PublicLayout>
          </Route>
          <Route
            path={[
              "/politica-de-datos",
              "/entrenamientos",
              "/instructores",
              "/nosotros",
              "/noticias",
              "/pqrfs",
              "/testimonios",
              "/",
            ]}
          >
            <PublicLayout>
              <Switch>
                <Route path={"/prueba"}>
                  <Test />
                  {/* <CursosLayout2 sections = {dataCursoPage} /> */}
                </Route>
                <Route path={"/politica-de-datos"}>
                  <PoliticaDatos />
                </Route>
                <Route path={"/entrenamientos"}>
                  <Entrenamientos />
                </Route>
                <Route path={"/instructores"}>
                  <Instructores />
                </Route>
                <Route path={"/pqrfs"}>
                  <Pqrfs />
                </Route>
                <Route path={"/testimonios"}>
                  <Testimonios />
                </Route>
                <Route path={"/"}>
                  <Index />
                </Route>
              </Switch>
            </PublicLayout>
          </Route>
        </Switch>
        <Footer />
        {/* <PublicLayout>
        </PublicLayout> */}
      </Router>
    </>
  );
}

export default App;
